<template>
    <div>
        <div class="w-100 text-sm-start text-center">
            <img src="@/assets/images/avatar.jpg" :alt="datas.about.title" class="d-sm-none img-thumbnail rounded-circle w-75 shadow" style="max-width:200px;" >

            <h1 class='text-secondary'>{{ datas.about.name }}</h1>

            <span class='text-primary'>
                {{ new Date().getFullYear() - datas.about.informations.birth }} ans, {{ datas.about.informations.location }}<br />
            </span>
        </div>


        <div class="my-5">
            <h2 class="text-success jetbrainsmono writer-wrapper">
                <span class="text-secondary">></span> Je suis
                <span class=''>
                    <vue-writer style="display:inline;text-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);" :array="datas.about.functions" :eraseSpeed="20" :typeSpeed="30" :delay="1000" /><b class='blink_me'>_</b>
                </span>
            </h2>
        </div>

        <div class="d-flex">
            <div class="pt-2">
                <i class="bi bi-chat-left-quote-fill me-3"></i>
            </div>
            <div class="">
                <p style="line-height: 2;">
                    {{ datas.about.introduction1 }}<br />
                    {{ datas.about.introduction2 }}<br />
                    {{ datas.about.introduction3 }}<br />
                </p>
            </div>
        </div>

        <div class="d-flex text-primary">
            <div class="pt-1">
                <i class="bi bi-stack me-3"></i>
            </div>
            <div class="">
                <p>
                    <span class="text-primary">{{ datas.about.favorite_stack }}</span>
                </p>
            </div>
        </div>


        <div class='mt-5'>
            <router-link :to="'/sheet'" class='shadow btn me-4 mb-4 text-capitalize btn-danger'>
                <i class="bi bi-filetype-pdf me-1"></i> Télécharger mon CV
            </router-link>

            <a class='shadow btn btn-dark me-4 mb-4 text-capitalize' :href="datas.about.linkedin" target="_blank">
                <i  class="bi bi-linkedin me-1"></i> Linkedin
            </a>

            <a class='shadow btn btn-success me-4 mb-4 text-lowercase' :href="'mailto:'+datas.about.mail">
                <i  class="bi bi-envelope-fill me-1"></i> cv@tfrichet.fr
            </a>


        </div>


    </div>
</template>

<script>
export default {
    name: 'SectionAbout',
    props : {
        section : { type : Object, required : true }
    },
    data : function() {
        return {

        }
    }
}
</script>

<style scoped>
@media only screen and (max-width: 1100px) {
    .writer-wrapper {
        font-size:1.5rem;
        height:2.5rem;
    }
}

.is-typed span.typed {
  color: black;
}

.is-typed span.cursor {
  display: inline-block;
  width: 3px;
  background-color: black;
  animation: blink 1s infinite;
}

.is-typed span.underscore {
  display: inline-flex;
  width: 10px;
  height: 1px;
  align-items:flex-end;
  background-color: black;
  animation: blink 1s infinite;
}

.is-typed span.cursor.typing {
  animation: none;
}

@keyframes blink {
  49% {
    background-color: black;
  }
  50% {
    background-color: transparent;
  }
  99% {
    background-color: transparent;
  }
}


.blink_me {
  animation: blinker 1s steps(1, end) infinite;
}

@keyframes blinker {
  50% { opacity: 0; }
}

</style>
